export const TableColumnsSezioni = ['Id', 'Descrizione', 'Progressivo', 'Codice sezione', 'Stato', 'Azioni'];
